import Editor from './Editor';
import { EditorTools } from './tools/main';
import { EditorToolsSettings } from './config/toolsSettings';
import { EditorUtils } from './utils';
import { EditorDialogs } from './dialogs/main';
import { EditorState, Plugin, PluginKey, Transaction, EditorView, Decoration, DecorationSet, Schema, NodeType, Node, MarkType, Mark, InputRule, inputRules, wrappingInputRule, textblockTypeInputRule, keymap, baseKeymap, history, dropCursor, gapCursor, tableNodes } from '@progress/kendo-editor-common';
var ProseMirror = {
    EditorState: EditorState, Plugin: Plugin, PluginKey: PluginKey, Transaction: Transaction, EditorView: EditorView, Decoration: Decoration, DecorationSet: DecorationSet,
    Schema: Schema, NodeType: NodeType, Node: Node, MarkType: MarkType, Mark: Mark,
    keymap: keymap, baseKeymap: baseKeymap, history: history, dropCursor: dropCursor, gapCursor: gapCursor, tableNodes: tableNodes,
    InputRule: InputRule, inputRules: inputRules, wrappingInputRule: wrappingInputRule, textblockTypeInputRule: textblockTypeInputRule
};
export { Editor, EditorTools, EditorToolsSettings, EditorUtils, EditorDialogs, ProseMirror };
//# sourceMappingURL=main.js.map